import appendScript from './appendScript';

const checkJQuery = () => {
    console.log('Checking jQUery!')
    if(typeof jQuery == 'undefined' && typeof $ == 'undefined'){
        appendScript('/assets/js/jquery.min.js');
    }
}
 
export default checkJQuery;